<template>
  <BaseModal id="bulk-category-selector" :value="true" @input="$emit('closed')">
    <div class="flex flex-col">
      <div
        class="filters-box flex flex-row top-0 mb-2 w-full bg-white grid grid-cols-2 gap-2"
      >
        <div class="flex flex-col p-2">
          <h2>Ebay Category assignation Tool</h2>
          <div class="grid grid-cols-3 gap-2">
            <div class="rounded-md flex flex-col justify-center">
              <label for="search">Search</label>
              <input
                type="text"
                id="search"
                class="bordered regular full"
                placeholder="code or description"
                v-model="filters.search"
                @input="search"
              />
            </div>
            <div class="flex flex-col justify-center">
              <label for="with-category">Products with category</label>
              <select
                name="with-category"
                id="with-category"
                class="default-select bordered dull"
                v-model="filters.categoryOnly"
                @change="search()"
              >
                <option value="no-category-only">No category only</option>
                <option value="">Any</option>
              </select>
            </div>
            <div class="flex flex-col justify-center">
              <label for="with-stock">Products with stock</label>
              <select
                name="with-stock"
                id="with-stock"
                class="default-select bordered dull"
                v-model="filters.stock"
                @change="search()"
              >
                <option value="with-stock-only">With stock only</option>
                <option value="">Any</option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="flex-grow flex justify-start flex-col bg-gray-200 rounded-md overflow-hidden p-2"
        >
          <h2>New category</h2>
          <div class="grid grid-cols-2 gap-2 items-center">
            <div class="flex flex-col" v-if="selectedCategory">
              <label for="categories">Selected Category</label>
              <div class="flex flex-row">
                <div
                  class="bg-red-500 p-1 rounded-md text-white font-bold text-center"
                  :title="selectedCategory.breadcrumb"
                >
                  {{ selectedCategory.partTerminologyName }} -
                  {{ selectedCategory.categoryId }}
                </div>
                <button @click="selectedCategory = ''" class="text-red-500">
                  Remove
                </button>
              </div>
            </div>
            <div class="flex flex-col text-center" v-else>
              <p>No Category selected</p>
              <button
                class="btn-info-button"
                @click="showEbayCategorySelector = true"
              >
                Open Category search
              </button>
            </div>
            <div class="flex justify-center mt-auto">
              <button
                v-if="selectedCategory"
                class="btn-success-button"
                @click="addCategories()"
              >
                Add ({{ selectedItem.length }} items)
              </button>
            </div>
          </div>
        </div>
      </div>
      <BaseMiniSpinner v-if="loading"></BaseMiniSpinner>
      <div id="filters" class="w-full bg-gray-200 border rounded-md p-4 mt-0">
        <div>{{ items.qty ? `Found (${items.qty})` : "" }}</div>
        <div></div>
        <div>NKR</div>
        <div>Unificado</div>
        <div>Description</div>
        <div>Category</div>
      </div>
      <div id="filters">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div id="items">
        <div
          class="item-line border border-gray-200"
          v-for="item in items.products"
          :key="item.nkrCode"
          :style="{
            backgroundColor: selectedItem.find(
              selected => selected == item.unificado
            )
              ? '#079d0773'
              : ''
          }"
        >
          <div
            class="flex justify-center"
            @click="selectCheckbox(item.unificado)"
          >
            <input
              class="my-5"
              @click.stop
              type="checkbox"
              :id="item.unificado"
              :name="item.unificado"
              :value="item.unificado"
              v-model="selectedItem"
            />
          </div>
          <div class="flex justify-center" v-if="item.image">
            <img :src="item.image" class="w-16 h-16 p-3" />
          </div>
          <div class="flex justify-center" v-else>
            <img src="@/assets/img/no-image-found.png" class="w-16 h-16 p-3" />
          </div>
          <div>{{ item.nkrCode }}</div>
          <div>{{ item.unificado }}</div>
          <div class="text-left">{{ item.title }}</div>
          <div :title="item.category" class="category-field">
            {{ item.category }}
          </div>
        </div>
      </div>
    </div>
    <EbayCategorySearch
      v-if="showEbayCategorySelector"
      @input="showEbayCategorySelector = false"
      @categorySelected="categorySelected"
    />
  </BaseModal>
</template>
<script>
import {
  getEbayCategoryProducts,
  addEbayCategoryToProduct
} from "@/api/store/EbayCategoriesService.js";
import EbayCategorySearch from "./EbayCategorySearch.vue";
export default {
  name: "BulkCategorySelector",
  components: {
    EbayCategorySearch
  },
  data() {
    return {
      filters: {
        storeEnabled: true,
        page: 1,
        limitPerPage: "50",
        orderCol: "nkr_code",
        orderDir: "asc",
        search: "",
        categoryOnly: "no-category-only",
        stock: "with-stock-only"
      },
      items: [],
      selectedItem: [],
      currentApiCallId: null,
      loading: false,
      selectedCategory: "",
      showEbayCategorySelector: false
    };
  },
  async mounted() {
    this.search();
  },
  methods: {
    selectCheckbox(id) {
      document.getElementById(id).click();
    },
    categorySelected(category) {
      this.selectedCategory = category;
      this.showEbayCategorySelector = false;
    },
    addCategories() {
      addEbayCategoryToProduct(
        this.selectedItem,
        this.selectedCategory.categoryId
      )
        .then(() => {
          this.$toast.open({
            message: "category added",
            type: "success",
            position: "top-right"
          });
          this.selectedItem = [];
          this.search();
        })
        .catch(err => {
          console.log(err);
          this.$toast.open({
            message: `Error adding categories`,
            type: "error",
            position: "top-right"
          });
        });
    },
    async search() {
      this.loading = true;
      this.selectedItem = [];
      this.currentApiCallId = new Date();
      let apiId = this.currentApiCallId;
      const res = await getEbayCategoryProducts(this.filters).catch(() => {
        console.log("Error getting Products");
      });
      if (apiId === this.currentApiCallId) {
        this.items = res;
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="postcss">
#bulk-category-selector.modal {
  padding: 20px;
  display: flex;
}
#bulk-category-selector .modal-content {
  width: 95%;
  height: 98%;
  padding: 0px;
  margin: auto;
}
#filters,
.item-line {
  @apply p-0;
  display: grid;
  align-items: center;
  grid-gap: 10px;
  text-align: center;
  grid-template-columns: 70px 70px 120px 120px 1fr 200px;
}
.filters-box {
  position: sticky;
}
.category-field {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
